/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductTypeValuesQueryResponse,
  FindProductTypeValuesQueryParams,
} from "../types/FindProductTypeValues.ts"

export const findProductTypeValuesQueryKey = (
  params?: FindProductTypeValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-type-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductTypeValuesQueryKey = ReturnType<
  typeof findProductTypeValuesQueryKey
>

/**
 * @summary Find product type values
 * {@link /v1/product/find-product-type-values}
 */
export async function findProductTypeValues(
  params?: FindProductTypeValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductTypeValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-type-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductTypeValuesQueryOptions(
  params?: FindProductTypeValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductTypeValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductTypeValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductTypeValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductTypeValues(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product type values
 * {@link /v1/product/find-product-type-values}
 */
export function useFindProductTypeValues<
  TData = ResponseConfig<FindProductTypeValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductTypeValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductTypeValuesQueryKey,
>(
  params?: FindProductTypeValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductTypeValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductTypeValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductTypeValuesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
